export const steps = [
  "ファイル選択",
  "全般データ確認・修正",
  "詳細データ確認・修正",
  "DBへ保存",
];

export const MAX_UPLOAD_SIZE_BYTES = 32 * 1000 * 1000;

// ポーリング関連の定数
export const MAX_RETRIES = 3;
export const RETRY_DELAY_MS = 5000;
export const POLLING_INTERVAL_GENERAL_MS = 5000;
export const POLLING_INTERVAL_DETAILED_MS = 10000;
export const POLLING_JITTER_MS = 1000;